import React, { useState } from "react";
import l from "components/util/l";
import { useRevisionFormContext } from "components/brief/reviewer/revision/RevisionForm.lib.context";
import View from "components/brief/reviewer/revision/layout/RevisionFormLayout.view";

const getFirstPrototypeFile = (prototypes = {}) => {
  return prototypes.html || null;
};

const RevisionFormLayout = ({
  saveRevisionForm,
  showProposalActions,
  isCreatingDevRevision,
  onClickSaveRevision,
  isSaving,
  onCloseSaveRevisionForm,
  onSubmitSaveRevisionForm,
  onClickSaveDraft,
  extraActions,
}) => {

  const {
    flow,
    isDeveloper,
    allowComments,
    content,
    selectedProposalIndex,
    activeSectionIndex,
    onClickPrevSection,
    onClickNextSection,
    onClickSelectSection,
    onClickEditProposal,
  } = useRevisionFormContext();

  const [isPrototypeOpen, setIsPrototypeOpen] = useState(false);

  const proposal = content.proposals[selectedProposalIndex];
  const prototypeFile = getFirstPrototypeFile(proposal.prototype || {});
  const proposalSections = proposal.content || [];
  const visibleSections = proposalSections
    .map((section, index) => {
      const hasComments = (section.annotations || []).some((annotation) => {
        if (!annotation?.id) return false;
        if (annotation?.is_solved) return false;
        if (!isDeveloper && (annotation?.visibility_scope || "CLIENT") === "DEV") return false;
        return true;
      });

      return {
        ...section,
        sourceIndex: index,
        hasComments,
      };
    })
    .filter(section => isDeveloper || section.type !== "dev");
  const sections = [
    { title: l("Propuesta Preliminar%PA518"), isStatic: true, staticType: "preliminary" },
    { title: l("Instrucciones%PA519"), isStatic: true, staticType: "objective" },
    { title: l("Índice%PA839"), isStatic: true, staticType: "index" },
    ...visibleSections,
  ].map((section, index) => ({
    ...section,
    stepIndex: index,
  }));

  if (allowComments)
    sections.push({ title: l("Comentarios Adicionales%PA433"), isExtra: true, stepIndex: sections.length });

  const currentSection = sections[activeSectionIndex] || {};
  const showSectionNavigator = sections.length > 1;

  return <View 
    flow={flow}
    sections={sections}
    currentSection={currentSection}
    indexSectionIndex={2}
    indexSections={sections.filter((section) => section.sourceIndex != null)}
    visibleSections={visibleSections}
    allowComments={allowComments}
    activeSectionIndex={activeSectionIndex}
    isSaving={isSaving}
    isCreatingDevRevision={isCreatingDevRevision}
    showProposalActions={showProposalActions}
    showSectionNavigator={showSectionNavigator}
    prototypeFile={prototypeFile}
    extraActions={extraActions}
    isPrototypeOpen={isPrototypeOpen}
    setIsPrototypeOpen={setIsPrototypeOpen}
    onClickPrevSection={onClickPrevSection}
    onClickNextSection={onClickNextSection}
    onClickSelectSection={onClickSelectSection}
    onClickEditProposal={onClickEditProposal}
    onClickSaveRevision={onClickSaveRevision}
    onCloseSaveRevisionForm={onCloseSaveRevisionForm}
    onSubmitSaveRevisionForm={onSubmitSaveRevisionForm}
    onClickSaveDraft={onClickSaveDraft}
    saveRevisionForm={saveRevisionForm}
  />;
  
}

export default RevisionFormLayout;
